import { ui } from "aaa";
import { NativeIconButton } from "components/common/NativeIconButton";
import * as React from "react";
import { IconChevronLeft } from "./primitives";

interface IProps {
    onClick: () => void;
    showRight?: boolean;
    size?: number;
    offset?: { x: number, y: number };
    iconClassName?: string;
}

/**
 * Renders close button X in the left top corner
 * @param props 
 */
export const BackButton = (props: IProps) => {
    let style: any = { position: "absolute", top: props.offset ? props.offset.y : 10, zIndex: 10 };
    if (props.showRight === true) {
        style.right = props.offset ? props.offset.x : 10;
    } else {
        style.left = props.offset ? props.offset.x : 10;
    }

    const iconStyle: React.CSSProperties = {
        ...(props.size ? { width: props.size, height: props.size } : undefined),
    };

    if (!props.iconClassName) {
        iconStyle.color = "white";
    }

    return (
        <NativeIconButton
            style={style}
            onClick={() => props.onClick()}
            aria-label={ui.__("a11y.back")}
        >
            <IconChevronLeft className={props.iconClassName} style={iconStyle} />
        </NativeIconButton>
    );

};



// WEBPACK FOOTER //
// ./src/components/util/BackButton.tsx